<template>
  <div>
    <Head title="Options" />
    <h1 class="mb-8 text-3xl font-bold">
      <span class="text-blue-400 hover:text-blue-600">Options</span>
    </h1>
    <div class="max-w-2xl bg-white  shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.website" :error="form.errors.website" class="pb-8 pr-6 w-full" label="Website" />
          <div class="flex mb-8 w-full gap-4">
            <file-input v-model="form.logo_black" :error="form.errors.logo_black" class="" type="file" accept="image/*" label="Logo Black" />
            <img v-if="logoBlack" class="w-1/2" :src="logoBlack" />
          </div>
          <div class="flex mb-8 w-full gap-4">
            <file-input v-model="form.logo_white" :error="form.errors.logo_white" class="" type="file" accept="image/*" label="Logo White" />
            <img v-if="logoWhite" class="w-1/2 bg-gray-600" :src="logoWhite" />
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue" type="submit">Update</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    website  : String,
    logoBlack: String,
    logoWhite: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        website   : this.website,
        logo_black: null,
        logo_white: null,
      }),
    }
  },
  methods: {
    update() {
      this.form.post('/options')
    },
  },
}
</script>
